import { render, staticRenderFns } from "./employeeCardInstitutions.vue?vue&type=template&id=59bb8dad"
import script from "./employeeCardInstitutions.vue?vue&type=script&lang=ts"
export * from "./employeeCardInstitutions.vue?vue&type=script&lang=ts"
import style0 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/components/common/modern/modern.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports